import {Injectable} from '@angular/core';
import {BundeslandEnumLabels, Finanzamt, StammdatenSteuernummer, BundeslandEnum} from '@nachdigal';
import {AbstractMapper} from '../../abstract.mapper';

@Injectable()
export class FinanzamtMapperService extends AbstractMapper<StammdatenSteuernummer, Finanzamt> {

  private static getBundeslandFromFinanzamtnummer(finanzamtnummer: string): BundeslandEnum {
    for (const key in BundeslandEnumLabels) {
      if (finanzamtnummer?.startsWith(BundeslandEnumLabels[key])) {
        return BundeslandEnumLabels[key];
      }
    }
    return undefined;
  }

  protected mapInternal(source: StammdatenSteuernummer): Finanzamt {
    let steuer = source.steuernummer?.replace(/[^\d]/g, '');
    if (source.finanzamtnummer?.startsWith('26')) {
      const endPosition = 11;
      steuer = steuer?.substring(1, endPosition);
    }

    return {
      finanzamtnummer: +source.finanzamtnummer,
      steuernummer: steuer,
      bundesland: FinanzamtMapperService.getBundeslandFromFinanzamtnummer(source.finanzamtnummer)
    };
  }
}
